import {APIClient} from "../../../api/httpClient";

import * as url from "./endpoints";

const api = new APIClient();
// postForgetPwd
export const postFakeForgetPwd = (data: any) =>
    api.create(url.POST_FAKE_PASSWORD_FORGET, data);


// postForgetPwd
export const postJwtForgetPwd = (data: any) =>
    api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);
